import moment from 'moment'

import { parseTime } from 'main/util/time'

export interface IAgeLabels {
  years: { full: string; abbreviated: string }
  months: { full: string; abbreviated: string }
  anyAge: string
}

export function getTimeInMinutes(time: string) {
  const { hour, minute } = parseTime(time)

  return hour * 60 + minute
}

export function getTimeAsString(time: number) {
  const hours = Math.floor(time / 60)
  const minutesLeftover = time % 60

  return moment.utc().hours(hours).minutes(minutesLeftover).seconds(0).format('HH:mm:ss')
}

// Formats to 'h:mma' (i.e. 8:30am)
export function formatTimeFromMinutes(minutes: number) {
  if (minutes >= 1440 || minutes < 0) {
    throw new RangeError('Valid input should be greater than or equal to 0 and less than 1440.')
  }
  const hours = minutes / 60
  const minutesLeftover = minutes % 60

  return moment.utc().hours(hours).minutes(minutesLeftover).format('h:mma')
}

export function formatTimeString(time: string) {
  return moment(time, 'HH:mm:ss').format('h:mma')
}

export function formatAgeFromMonths(
  months: number,
  displayBoundsAsAnyAge: boolean,
  displayAsAbbreviations: boolean,
  labels?: IAgeLabels,
) {
  const yearsLabels = labels?.years || { full: 'years', abbreviated: 'yrs' }
  const monthsLabels = labels?.months || { full: 'months', abbreviated: 'mos' }
  const anyAge = labels?.anyAge || 'Any Age'

  const yearsText = displayAsAbbreviations ? yearsLabels.abbreviated : yearsLabels.full
  const monthsText = displayAsAbbreviations ? monthsLabels.abbreviated : monthsLabels.full
  const years = Math.trunc(months / 12)
  const rem = months % 12

  if (months === 0) {
    return displayBoundsAsAnyAge ? anyAge : months + ' ' + monthsText
  }

  if (months === 11 * 12) {
    return displayBoundsAsAnyAge ? anyAge : years + ' ' + yearsText
  }

  if (years < 2) {
    return months + ' ' + monthsText
  }

  if (rem >= 6) {
    return years + '.5' + ' ' + yearsText
  }

  return years + ' ' + yearsText
}

export function formatMonthlyBudgetFromDollars(dollars: number, max: number) {
  if (dollars === max) {
    return '$' + dollars + '+'
  }

  return '$' + dollars
}

export function formatWeeklyBudgetFromDollars(dollars: number, max: number) {
  const weeklyAmount = Math.trunc(dollars / 4)

  if (dollars === max) {
    return '$' + weeklyAmount + '+'
  }

  return '$' + weeklyAmount
}
